import React, { useEffect, useState } from "react";
import { RealWorldCoordinate } from "../types";

interface CalibrationModalProps {
  show: boolean;
  stepNumber: number;
  onCancel: () => void;
  onSave: (coord: RealWorldCoordinate) => void;
}

const CalibrationModal: React.FC<CalibrationModalProps> = ({
  show,
  stepNumber,
  onCancel,
  onSave,
}) => {
  const [northing, setNorthing] = useState("");
  const [easting, setEasting] = useState("");
  const [errors, setErrors] = useState<{ northing?: string; easting?: string }>(
    {},
  );

  useEffect(() => {
    if (show) {
      setNorthing("");
      setEasting("");
      setErrors({});
    }
  }, [show]);

  const validate = () => {
    const next: { northing?: string; easting?: string } = {};
    if (!northing.trim()) next.northing = "Northing is required";
    else if (isNaN(Number(northing))) next.northing = "Must be a number";
    if (!easting.trim()) next.easting = "Easting is required";
    else if (isNaN(Number(easting))) next.easting = "Must be a number";
    setErrors(next);
    return Object.keys(next).length === 0;
  };

  const handleSave = () => {
    if (!validate()) return;
    onSave({ northing: Number(northing), easting: Number(easting) });
  };

  return (
    <div className={`modal-backdrop ${show ? "show" : ""}`}>
      <div className="modal" style={{ maxWidth: 420 }}>
        <div className="modal-head">
          <h3>Calibration Point {stepNumber}</h3>
          <button type="button" className="btn btn-sm" onClick={onCancel}>
            <i className="bi bi-x-lg" />
          </button>
        </div>
        <div className="modal-body">
          <p className="text-muted" style={{ marginTop: 0 }}>
            Enter the real-world HK1980 coordinates for the point you clicked.
          </p>
          <div className="grid cols-2" style={{ gap: 12 }}>
            <div className="field">
              <label>Northing (N)</label>
              <input
                className="input"
                type="number"
                value={northing}
                onChange={(e) => setNorthing(e.target.value)}
                placeholder="e.g. 819900"
              />
              {errors.northing && (
                <span className="text-danger" style={{ fontSize: 12 }}>
                  {errors.northing}
                </span>
              )}
            </div>
            <div className="field">
              <label>Easting (E)</label>
              <input
                className="input"
                type="number"
                value={easting}
                onChange={(e) => setEasting(e.target.value)}
                placeholder="e.g. 835500"
              />
              {errors.easting && (
                <span className="text-danger" style={{ fontSize: 12 }}>
                  {errors.easting}
                </span>
              )}
            </div>
          </div>
        </div>
        <div className="modal-foot">
          <button type="button" className="btn" onClick={onCancel}>
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={handleSave}
          >
            Save Point
          </button>
        </div>
      </div>
    </div>
  );
};

export default CalibrationModal;
